import React from 'react'
import {connect} from 'react-redux'
import actions from 'redux-auto'
import PropTypes from 'prop-types'
import MenuBurger from '#components/svg/icons/MenuBurger'
import MenuClose from '#components/svg/icons/MenuClose'

export function MobileMenuToggleButton({mobileMenuOpen, toggleMenu}) {
  return (
    <button className="menuBurgerButton" type="button" onClick={() => toggleMenu()}>
      {mobileMenuOpen ? <MenuClose /> : <MenuBurger />}
    </button>
  )
}

MobileMenuToggleButton.propTypes = {
  mobileMenuOpen: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  mobileMenuOpen: state.mobileMenu.open,
})

const mapDispatchToProps = () => ({
  toggleMenu: actions.mobileMenu.toggleMenu,
})

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenuToggleButton)
